window.addEventListener("pplrAppInitiated", function (e) { 
  
// Select the mainBtn element
let mainBtn = $('.product-personalizer .pplr-btn');
console.log(mainBtn);

// Create a new checkbox element
let checkbox = $('<input type="checkbox" class="new-checkbox">');

// Insert the checkbox before the mainBtn
mainBtn.before(checkbox);

// calling the pop up with checkbox
  $(function() {
  $('.new-checkbox').on('change', function() {
    if ($(this).is(':checked')) {
      $(this).next('button').click();
    }
  });
});
  
//select the span element
let spanElement = document.querySelector('.product-personalizer .pplr-btn span');
spanElement.classList.add('priceStyle');

const closeButton = $('.js-modal-close .pplr_close .p_r_c i').html('<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>');

 console.log(closeButton);

})



